import React from 'react';
import { useParams } from 'react-router-dom';
import ReactTable from 'src/views/dashboard/elements/ReactTable';

function Config() {
    // Get the client_id and module_id from the URL
    const { client_id, module_id } = useParams();
  
    return (
      <>
        <div className='p-2' style={{ marginTop: '0.5%' , overflow: 'hidden'}}>
          <ReactTable client_id={client_id} module_id={module_id} module="kpiDashboard" tabname="config" isFetching={false} />
        </div>
      </>
    );
  }
  
  export default Config;
  